import React from 'react';
import {
  Grid,
  Typography,
  Card,
  CardContent,
  CardHeader,
  CardActions,
  Button,
  Divider,
} from '@mui/material';
import { Circle } from '@mui/icons-material';

const ButtonLink = ({ href, label }) => (
  <Button
    size="small"
    variant="text"
    color="primary"
    href={href}
    target="_blank"
    rel="noopener"
  >
    {label}
  </Button>
);

export default function IPSLandingPage() {
  return (
    <Grid container>
      <Grid item xs={12} textAlign="center" padding>
        <Typography variant="h5" sx={{ fontWeight: 'bold' }}>
          IPS (International Peace Scholarship)
        </Typography>
      </Grid>
      <Grid item xs={2} />
      <Grid item xs={8} textAlign="center">
        <Typography variant="body1" sx={{ fontStyle: 'italic' }}>
          The International Peace Scholarship (IPS) Fund provides scholarships
          for international women students to pursue graduate study in the U.S.
          or Canada. P.E.O. is celebrating 75 years of IPS in 2024!
        </Typography>
      </Grid>
      <Grid item xs={2} />
      <Grid item xs={12} padding>
        <Card
          sx={{
            boxShadow: 3,
            borderRadius: 2,
            overflow: 'auto',
          }}
        >
          <CardHeader
            title="Local Chapter Process"
            subheader="The eligibility period is September 15 to December 15. The online eligibility form will be posted to this page in September 2025."
          />
          <CardContent>
            <Grid container xs={12}>
              <Grid item xs={6}>
                <Typography
                  variant="body1"
                  padding
                  sx={{ fontWeight: 'bold', backgroundColor: 'lightblue' }}
                >
                  Step
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography
                  variant="body1"
                  padding
                  sx={{ fontWeight: 'bold', backgroundColor: 'lightblue' }}
                >
                  Resources
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="body1" padding>
                  Announcement of awards is made in May.
                </Typography>
              </Grid>
              <Grid item container xs={6} spacing={1}>
                <Grid item>
                  <ButtonLink
                    href="https://www.peointernational.org/wp-content/uploads/2023/11/IPS-Application-Calendar.pdf"
                    label="2025-2026 IPS Application Calendar"
                  />
                </Grid>
              </Grid>
              <Grid item xs={12} padding>
                <Divider />
              </Grid>
              <Grid item xs={6}>
                <Typography variant="body1" padding>
                  P.E.O. International Peace Scholarship Fund Policies and
                  Procedures
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <ButtonLink
                  href="https://www.peointernational.org/wp-content/uploads/2023/11/IPSPoliciesandProcedures_10.2024.pdf"
                  label="P.E.O. International Peace Scholarship Fund Policies and Procedures"
                />
              </Grid>
              <Grid item xs={12} padding>
                <Divider />
              </Grid>
              <Grid item xs={6}>
                <Typography variant="body1" padding>
                  IPS Board of Trustees Student Selection Process
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <ButtonLink
                  href="https://www.peointernational.org/wp-content/uploads/2023/11/IPSStudentSelectionProcess_10.2024.pdf"
                  label="IPS Board of Trustees Student Selection Process"
                />
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
      <Grid item xs={12} padding>
        <Card
          sx={{
            boxShadow: 3,
            borderRadius: 2,
            overflow: 'auto',
          }}
        >
          <CardHeader
            title="Eligibility Requirements"
            sx={{ pb: 0 }}
            subheader="A woman is eligible for consideration for an International Peace Scholarship if she:"
          />
          <CardContent>
            <Grid container xs={12}>
              <Grid item xs={12}>
                <Typography variant="body1" padding>
                  <Circle sx={{ fontSize: 10, pr: 2 }} />
                  is a woman outside the United States and Canada who is seeking
                  an advanced degree from an accredited college or university in
                  the U.S. or Canada;
                </Typography>
              </Grid>
              <Grid item xs={1} />
              <Grid item xs={11}>
                <Typography variant="body1" padding>
                  <Circle sx={{ fontSize: 10, pr: 2 }} />
                  will return to her home country to utilize her education to
                  make a positive impact and foster global peace; and
                </Typography>
              </Grid>
              <Grid item xs={1} />
              <Grid item xs={11}>
                <Typography variant="body1" padding>
                  <Circle sx={{ fontSize: 10, pr: 2 }} />
                  has a full year of formal coursework remaining and is enrolled
                  and in residence in the U.S. or Canada for the entire school
                  year; or
                </Typography>
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <Typography variant="body1" padding>
                <Circle sx={{ fontSize: 10, pr: 2 }} />
                is an international student attending Cottey College
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography variant="body1" sx={{ fontWeight: 'bold' }} padding>
                Please Note:
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography variant="body1" padding>
                <Circle sx={{ fontSize: 10, pr: 2 }} />
                Doctoral students who have completed coursework and are working
                only on dissertations are not eligible as first-time applicants.
              </Typography>
            </Grid>

            <Grid item xs={12}>
              <Typography variant="body1" padding>
                <Circle sx={{ fontSize: 10, pr: 2 }} />A student who is a
                citizen or permanent resident of the United States or Canada is
                not eligible. A student with residency for tax purposes only is
                permitted.
              </Typography>
            </Grid>

            <Grid item xs={12}>
              <Typography variant="body1" padding>
                <Circle sx={{ fontSize: 10, pr: 2 }} />
                Scholarships are not given for online courses, research,
                internships or for practical training if not combined with
                formal coursework.
              </Typography>
            </Grid>

            <Grid item xs={12}>
              <Typography variant="body1" padding>
                <Circle sx={{ fontSize: 10, pr: 2 }} />
                At the time of application, the applicant is required to
                indicate additional financial resources adequate to meet her
                estimated expenses. (ie: personal and family funds, tuition
                waivers, work, scholarships, teaching assistantships, study
                grants and other scholarships)
              </Typography>
            </Grid>

            <Grid item xs={12}>
              <Typography variant="body1" padding>
                <Circle sx={{ fontSize: 10, pr: 2 }} />
                The maximum amount awarded to a student is $12,500. Lesser
                amounts may be awarded according to individual needs.
              </Typography>
            </Grid>
          </CardContent>
          <CardActions>
            <Grid container xs={12}>
              <Grid item xs={12} padding textAlign="center">
                <Typography variant="caption" sx={{ fontWeight: 'bold' }}>
                  The eligibility period is September 15 to December 15. The
                  online eligibility form will be posted to this page in
                  September 2025.
                </Typography>
              </Grid>
              <Grid container xs={12} paddingBottom={2}>
                <Grid item xs={12} textAlign="center" padding>
                  <Button variant="contained" color="primary" disabled>
                    Access IPS Eligibility Form
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </CardActions>
        </Card>
      </Grid>
    </Grid>
  );
}
